import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../../Shared/Services/api.service';
import { endpoints } from '../../../../environments/endpoints';
import { LaravelDefaultResponse } from '../../../Interfaces/api/shared/response.interface';
import {
  FeatureCatalogueResponse,
  PlanFeatureMatrixResponse,
} from '../../../Interfaces/api/backoffice/feature.interface';
import { TypedResourceRequest } from '../../Shared/Interfaces/api-request.interface';
import { PlanFeature } from '../../../Models/backoffice/plan-feature.model';

@Injectable({
  providedIn: 'root',
})
export class PlanFeatureService {
  private readonly _apiService = inject(ApiService);

  catalogueRequest(): TypedResourceRequest<LaravelDefaultResponse<FeatureCatalogueResponse>> {
    return this._apiService.get<LaravelDefaultResponse<FeatureCatalogueResponse>>(
      endpoints.backoffice.features,
      { skipLoading: true },
    );
  }

  matrixRequest(
    planId: string,
  ): TypedResourceRequest<LaravelDefaultResponse<PlanFeatureMatrixResponse>> {
    return this._apiService.get<LaravelDefaultResponse<PlanFeatureMatrixResponse>>(
      endpoints.backoffice.planFeatures(planId),
      { skipLoading: true },
    );
  }

  sync(planId: string, featureIds: string[]): Observable<PlanFeature[]> {
    const request = this._apiService.put<LaravelDefaultResponse<PlanFeatureMatrixResponse>>(
      endpoints.backoffice.planFeatures(planId),
      { body: { feature_ids: featureIds }, skipError: true },
    );

    return this._apiService
      .run<LaravelDefaultResponse<PlanFeatureMatrixResponse>>(request)
      .pipe(map((response) => this.toMatrix(response)));
  }

  toMatrix(response: LaravelDefaultResponse<PlanFeatureMatrixResponse> | undefined): PlanFeature[] {
    return (response?.data?.features ?? []).map((row) => new PlanFeature(row));
  }

  toGrantedIds(response: LaravelDefaultResponse<PlanFeatureMatrixResponse> | undefined): string[] {
    return response?.data?.feature_ids ?? [];
  }
}
